import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Fab,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  SvgIcon,
  Tooltip,
} from "@mui/material";
import TreeView from "@mui/lab/TreeView";
import TreeItem from "@mui/lab/TreeItem";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

import BreadcrumbsComponent from "../../../components/shared/breadcrumbs";

function MinusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
    </SvgIcon>
  );
}

function PlusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
    </SvgIcon>
  );
}

const SettingReportTreePage = () => {
  const [expanded, setExpanded] = React.useState([]);
  const [selected, setSelected] = React.useState([]);

  const data = {
    id: "root",
    name: "شرکت توزیع استان اصفهان",
    children: [
      {
        id: "1",
        name: "آران وبیدگل",
        children: [
          {
            id: "11",
            name: "ترانسفورماتور - T2(201654977741)",
          },
          {
            id: "12",
            name: "ترانسفورماتور - T1(201654977741)",
          },
          {
            id: "13",
            name: "تبادلی - T1-F11(201654977741)",
          },
          {
            id: "14",
            name: "فهم تبادلی - T1-F11(11051947129878)",
          },
        ],
      },
      {
        id: "2",
        name: "بادرود",
        children: [
          {
            id: "23",
            name: "تبادلی - T1-F11(201654977741)",
          },
          {
            id: "24",
            name: "فهم تبادلی - T1-F11(11051947129878)",
          },
        ],
      },
      {
        id: "3",
        name: "راوند",
        children: [
          {
            id: "33",
            name: "تبادلی - T1-F11(201654977741)",
          },
          {
            id: "34",
            name: "فهم تبادلی - T1-F11(11051947129878)",
          },
        ],
      },
      {
        id: "4",
        name: "اصفهان",
      },
    ],
  };

  const renderTree = (nodes) => (
    <TreeItem key={nodes.id} nodeId={nodes.id} label={nodes.name}>
      {Array.isArray(nodes.children)
        ? nodes.children.map((node) => renderTree(node))
        : null}
    </TreeItem>
  );

  const getTreeIds = (nodes) => {
    let ids = [nodes.id];
    if (Array.isArray(nodes.children)) {
      for (let i = 0; i < nodes.children.length; i++) {
        const node = nodes.children[i];
        ids = [...ids, ...getTreeIds(node)];
      }
    }
    return ids;
  };

  const handleToggle = (event, nodeIds) => {
    setExpanded(nodeIds);
  };

  const handleSelect = (event, nodeIds) => {
    setSelected(nodeIds);
  };

  const handleExpandClick = () => {
    setExpanded((oldExpanded) =>
      oldExpanded.length === 0 ? getTreeIds(data) : []
    );
  };

  const handleSelectClick = () => {
    console.log("ids", getTreeIds(data));
    setSelected((oldSelected) =>
      oldSelected.length === 0 ? getTreeIds(data) : []
    );
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title="وضعیت ارتباط سرویس ها در ده روز گذشته"
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <RadioGroup row>
                  <FormControlLabel
                    value="input"
                    control={<Radio />}
                    label="ورودی"
                  />
                  <FormControlLabel
                    value="output"
                    control={<Radio />}
                    label="خروجی"
                  />
                </RadioGroup>
              </Box>
            }
          />
          <CardContent>
            <Grid container>
              <Grid item xs={12} md={4}>
                <Paper elevation={3} sx={{ p: 2 }}>
                  <Box
                    sx={{ mb: 1, display: "flex", justifyContent: "flex-end" }}
                  >
                    <Tooltip
                      placement="top"
                      title={expanded.length === 0 ? "بازکردن همه" : "بستن همه"}
                    >
                      <Fab
                        color="primary"
                        onClick={handleExpandClick}
                        size="small"
                        sx={{ mx: 1 }}
                      >
                        {expanded.length === 0 ? (
                          <PlusSquare />
                        ) : (
                          <MinusSquare />
                        )}
                      </Fab>
                    </Tooltip>

                    <Tooltip
                      placement="top"
                      title={selected.length === 0 ? "انتخاب همه" : "لغو همه"}
                    >
                      <Fab
                        color="info"
                        onClick={handleSelectClick}
                        size="small"
                      >
                        {selected.length === 0 ? (
                          <CheckBoxIcon />
                        ) : (
                          <CheckBoxOutlineBlankIcon />
                        )}
                      </Fab>
                    </Tooltip>
                  </Box>

                  <TreeView
                    aria-label="rich object"
                    defaultCollapseIcon={<ExpandMoreIcon />}
                    defaultExpanded={["root"]}
                    defaultExpandIcon={<ChevronLeftIcon />}
                    sx={{
                      flexGrow: 1,
                      overflowY: "auto",
                      minHeight: "50vh",
                    }}
                    expanded={expanded}
                    selected={selected}
                    onNodeToggle={handleToggle}
                    onNodeSelect={handleSelect}
                  >
                    {renderTree(data)}
                  </TreeView>
                </Paper>
              </Grid>
              <Grid item xs={12} md={8}>
                table is coming hear ...
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default SettingReportTreePage;
